import {ajax} from "@timgroup/common-javascript-components";

export function logAction(action, printConsoleLog = false) {
    if (!action || !action.type) {
        console.warn("logAction called with invalid action", action);
    }
    log("Action", {actionTypeTIM2: action});
    if (printConsoleLog && process.env.NODE_ENV !== "production") {
        console.log(`Logged user action: ${JSON.stringify(action)}`);
    }
    return action;
}

export function log(subtype, customFields = {}) {
    if (process.env.NODE_ENV !== "test") {
        sendLogEventTo("/ui/api/log", subtype, customFields);
    }
}

function sendLogEventTo(logApiUrl, subtype, customFields = {}) {
    const httpPost = ajax.post(logApiUrl, {
        type: "ClientEvent",
        subtype,
        client_timestamp: new Date().toISOString(),
        user_agent: window.navigator.userAgent, ...customFields
    });

    httpPost.subscribe(
        ({ data, code, xhr }) => { },
        ({ code, xhr }) => { },
        () => { }
    );
}
